export default __webpack_public_path__ + "static/gw2-banner-community-d6caaf0c356a1f22855785c0661e0a3f.png";